// Function to update the tab content
const updateTabContent = (trigger, target) => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });

  setTimeout(() => {
    trigger
      .closest('.tabs')
      .querySelectorAll('.tabs__item')
      .forEach((el) => {
        el.classList.remove('tabs__item--active');
        el.classList.add('tabs__item--inactive');
      });
    trigger.closest('.tabs').querySelector(`#${target}`).classList.remove('tabs__item--inactive');
    trigger.closest('.tabs').querySelector(`#${target}`).classList.add('tabs__item--active');
  }, 500);
};

(() => {
  // Sidebar menu triggers
  const trigger = document.querySelectorAll('.tabs__sidebar .tab-trigger');
  trigger.forEach((el) => {
    el.addEventListener('click', () => {
      // Update active state of triggers
      trigger.forEach((tab) => tab.classList.remove('link-styled--active'));
      el.classList.add('link-styled--active');

      // Update tab content
      if (document.getElementById(el.dataset.trigger)) {
        updateTabContent(el, el.dataset.trigger);
        window.location.hash = el.dataset.trigger;
      }
    });
  });
})();

// Select menu event listener
document.getElementById('TabsSidebarSelect').addEventListener('change', (el) => {
  if (document.getElementById(el.target.value)) {
    updateTabContent(el.target, el.target.value);
    window.location.hash = el.target.value;
  }
});

// Check for URL hash on load
document.addEventListener('DOMContentLoaded', function () {
  var hash = window.location.hash;

  if (hash) {
    var id = hash.slice(1);
    var el = document.querySelector(`.tab-trigger[data-trigger="${id}"]`);
    el.click();
  }
});
